import * as actionTypes from '../../constants/action-types/auth'

export const receiveUser = (user) => ({
    type: actionTypes.RECEIVE_USER,
    payload: {user}
});

export const receiveStudent = (student) => ({
    type: actionTypes.RECEIVE_STUDENT,
    payload: {student}
});

export const logoutSuccess = () => ({
    type: actionTypes.LOGOUT_SUCCESS,
});